import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "pricing-plans xyz-in container",
  xyz: "fade down-3 duration-6 delay-1"
}
const _hoisted_2 = { class: "head d-flex align-c justify-between mb-4" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = { class: "card bg-white" }
const _hoisted_6 = { class: "tag bg-light text-dark" }
const _hoisted_7 = { class: "mt-2" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "text-dark" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "card bg-primary text-white" }
const _hoisted_13 = { class: "text-primary bg-white tag" }
const _hoisted_14 = { class: "mt-2" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = {
  class: "mt-1 mb-2",
  style: {"opacity":"0.66"}
}

import { strings } from '@/strings'
import { checkout } from '@/utils/checkout'
import CurrencySelect from '@/components/ui/currency-select.vue'
import { onMounted, ref } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'plans',
  setup(__props) {

const trial_price = ref("")
const sub_price = ref("")
const trail_par = ref("")

onMounted(() => {
  setTimeout(() => {
    trial_price.value = checkout.trial_price()
    sub_price.value = checkout.subscription_price()
    trail_par.value = strings.pricing[7].replace('€29.90', checkout.subscription_price())
  }, 200)

})


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", null, _toDisplayString(_unref(strings).core['Pricing']), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", null, [
            _createElementVNode("h6", _hoisted_6, _toDisplayString(_unref(strings).pricing[5]), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("h3", {
              class: "text-primary no-wrap",
              innerHTML: trial_price.value
            }, null, 8, _hoisted_8),
            _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(strings).pricing[6]), 1)
          ]),
          _createElementVNode("p", {
            class: "mt-1 mb-2 text-gray",
            innerHTML: trail_par.value
          }, null, 8, _hoisted_10),
          _createVNode(_component_router_link, {
            to: "/sign-up",
            class: "btn block bg-light"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(strings).pricing[8].toLowerCase()), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", null, [
            _createElementVNode("h6", _hoisted_13, _toDisplayString(_unref(strings).pricing[9]), 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("h3", {
              class: "no-wrap",
              innerHTML: sub_price.value
            }, null, 8, _hoisted_15),
            _createElementVNode("p", null, _toDisplayString(_unref(strings).pricing[10]), 1)
          ]),
          _createElementVNode("p", _hoisted_16, _toDisplayString(_unref(strings).pricing[11]), 1),
          _createVNode(_component_router_link, {
            to: "/sign-up",
            class: "btn block bg-secondary sh"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(strings).pricing[12]), 1)
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})